import { useState } from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import { Link, useNavigate } from 'react-router-dom'
import { useFormik } from 'formik'
import { forgotPassword } from '../core/_requests'
import { useDispatch } from 'react-redux'
import { setMessage } from '../../../../store/alertMessage/actions'

const initialValues = {
  email: '',
}

const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 character is required')
    .max(50, 'Maximum 50 character is required')
    .required('Email is required'),
})

export function ForgotPassword() {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      try {
        setLoading(true)
        forgotPassword(values).then((data: any) => {
          if (data.responseStatus == 200) {
            dispatch(setMessage("success", data.responseMessage))
            setTimeout(()=>{
              navigate('/auth/login')
            },2500)
          }
          else {
            dispatch(setMessage("error", data.responseMessage))
          }
          setLoading(false)
        }).catch((error:any) => {
          if (error?.response?.data?.responseData?.msg) {
            dispatch(setMessage("error", error?.response?.data?.responseData?.msg))
          }
          else if (error?.response?.data?.responseMessage) {
            dispatch(setMessage("error", error?.response?.data?.responseMessage))
          }
          else {
            dispatch(setMessage("error", error?.message))
          }
          setLoading(false)
        })
      } catch (error: any) {
        dispatch(setMessage("error", error.message ? error.message : "Something Went Wrong"))
        setLoading(false)
      }
    }
  })

  return (
    <form
      className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
      noValidate
      id='kt_login_password_reset_form'
      onSubmit={formik.handleSubmit}
    >
      <div className='text-center mb-10'>
        {/* begin::Title */}
        <h1 className='text-dark fw-bolder mb-3'>Forgot Password ?</h1>
        {/* end::Title */}

        {/* begin::Link */}
        <div className='text-gray-500 fw-semibold fs-6'>
          Enter your email to reset your password.
        </div>
        {/* end::Link */}
      </div>

      {/* begin::Form group */}
      <div className='fv-row mb-8'>
        <label className='form-label fw-bolder  text-gray-900 fs-6'>Email</label>
        <input
          type='email'
          placeholder='Email'
          autoComplete='off'
          {...formik.getFieldProps('email')}
          className={clsx(
            'form-control bg-transparent',
            { 'is-invalid': formik.touched.email && formik.errors.email },
            {
              'is-valid': formik.touched.email && !formik.errors.email,
            }
          )}
        />
        {formik.touched.email && formik.errors.email && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.email}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
        <button type='submit' id='kt_password_reset_submit' className='btn me-4'
          disabled={loading}
        >
          <span className='indicator-label'>{ loading ? "Please Wait..." : "Submit" }</span>
        </button>
        <Link to='/auth/login'>
          <button
            type='button'
            id='kt_login_password_reset_form_cancel_button'
            className='btn btn-light'
            disabled={formik.isSubmitting || !formik.isValid || loading}
          >
            Cancel
          </button>
        </Link>{' '}
      </div>
      {/* end::Form group */}
    </form>
  )
}
